import { STATUS, API } from '../constants/ServiceMSGConstants'

export const checkResStatusService = ({ status, api }) => {
    if (status) {
        return STATUS[status] && STATUS[status][api] && STATUS[status][api]
    } else if (api === API.CONNEXT) {
        return STATUS[503][api]
    }
}